<ion-content class="modal-border">
  <ion-header>
    <ion-toolbar text-center>
      <div *ngIf="paramObject.data.Type == 'Lesson'">
        <ion-icon name="create"></ion-icon>
        <ion-title>{{paramObject.data.Name}}</ion-title>
      </div>

      <div *ngIf="paramObject.data.Type == 'Module'">
        <ion-icon name="folder"></ion-icon>
        <ion-title>{{paramObject.data.Name}}</ion-title>
      </div>

      <div *ngIf="paramObject.data.Type == 'Scene'">
        <ion-icon name="copy"></ion-icon>
        <ion-title>{{paramObject.data.Name}}</ion-title>
      </div>

      <div *ngIf="paramObject.data.Type == 'Content'">
        <ion-icon name="create"></ion-icon>
        <ion-title>{{paramObject.data.Name}}</ion-title>
      </div>
    </ion-toolbar>
  </ion-header>

  <div padding>
    <ion-grid>
      <ion-row>
        <ion-col text-center> </ion-col>
      </ion-row>
      <div *ngIf="paramObject.data.Type == 'Lesson'" text-center>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-icon name="add" color="success"></ion-icon>
              <ion-button
                (click)="onButtonPress('AddModule')"
                class="menuitem-ion-button"
                >Add a Module to this lesson</ion-button
              >
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-item-divider> </ion-item-divider>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-icon name="people"></ion-icon>
              <ion-button
                (click)="onButtonPress('AssignPeople')"
                class="menuitem-ion-button"
                >Assign Users</ion-button
              >
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-icon name="people"></ion-icon>
              <ion-button
                (click)="onButtonPress('AssignOccupation')"
                class="menuitem-ion-button"
                >Assign Occupation</ion-button
              >
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-icon name="alarm"></ion-icon>
              <ion-button
                (click)="onButtonPress('SchedulePeople')"
                class="menuitem-ion-button"
                >Schedule People</ion-button
              >
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-icon name="copy"></ion-icon>
              <ion-button
                (click)="onButtonPress('CopyLesson')"
                class="menuitem-ion-button"
                >Copy Lesson</ion-button
              >
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-icon name="exit"></ion-icon>
              <ion-button
                (click)="onButtonPress('ExportLesson')"
                class="menuitem-ion-button"
                >Export Lesson</ion-button
              >
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-icon name="calendar"></ion-icon>
              <ion-button
                (click)="onButtonPress('SiteAssignment')"
                class="menuitem-ion-button"
                >Site Assignment</ion-button
              >
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-icon name="list"></ion-icon>
              <ion-button
                (click)="onButtonPress('ImportQuestions')"
                class="menuitem-ion-button"
                >Import Modules and questions</ion-button
              >
            </ion-item>
          </ion-col>
        </ion-row>
      </div>

      <div *ngIf="paramObject.data.Type == 'Module'" text-center>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-icon name="add" color="success"></ion-icon>
              <ion-button
                (click)="onButtonPress('AddScene')"
                class="menuitem-ion-button"
                >Add a Scene to this module</ion-button
              >
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-icon name="remove" color="danger"></ion-icon>
              <ion-button
                (click)="onButtonPress('RemoveModule')"
                class="menuitem-ion-button"
                >Delete this module
              </ion-button>
            </ion-item>
          </ion-col>
        </ion-row>
      </div>

      <div *ngIf="paramObject.data.Type == 'Scene'" text-center>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-icon name="add" color="success"></ion-icon>
              <ion-button
                (click)="onButtonPress('AddQuestion')"
                class="menuitem-ion-button"
                >Add a Question</ion-button
              >
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-icon name="add" color="success"></ion-icon>
              <ion-button
                (click)="onButtonPress('UploadMediaToScene')"
                class="menuitem-ion-button"
                >Add Media ( Pictures | Video | Documents )</ion-button
              >
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-icon name="remove" color="danger"></ion-icon>
              <ion-button
                (click)="onButtonPress('RemoveScene')"
                class="menuitem-ion-button"
                >Delete this scene</ion-button
              >
            </ion-item>
          </ion-col>
        </ion-row>
      </div>

      <div *ngIf="paramObject.data.Type == 'Content'" text-center>
        <ion-row>
          <ion-col>
            <ion-item>
              <ion-icon name="remove" color="danger"></ion-icon>
              <ion-button
                (click)="onButtonPress('RemoveMedia')"
                class="menuitem-ion-button"
                >Remove media item</ion-button
              >
            </ion-item>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col> </ion-col>
        </ion-row>
      </div>
    </ion-grid>
  </div>
</ion-content>
